var map = {
	"./50-50-az.svg": "ce08",
	"./50-50.svg": "18aa",
	"./b1.svg": "691d",
	"./b2.svg": "6954",
	"./bexterno.svg": "4b2d",
	"./bg.svg": "2370",
	"./borde1.svg": "082b",
	"./img_boy_game.svg": "d2b3",
	"./pages/login/facebook.svg": "4631",
	"./pages/login/github.svg": "7b1e",
	"./pages/login/google.svg": "74c7",
	"./pages/login/twitter.svg": "ceb3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";